import React from "react";
import styles from "../../asset/Fotter/Fotter.module.scss";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaEnvelope, FaPhone } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../asset/homefour/logo.svg";

const Fotter = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.logoSection}>
          <img src={Logo} alt="Saidigitizing" className={styles.logoImg} />
          <p>Leave an impression!</p>
        </div>

        <div className={styles.linksSection}>
          <div className={styles.companyLinks}>
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/service">Services</Link></li>
              <li><Link to="/Portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className={styles.usefulLinks}>
            <h3>Useful Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/clients">Clients</Link></li>
            </ul>
          </div>
          <div className={styles.contactSection}>
            <h3>Contact Us</h3>
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <FaEnvelope className={styles.contactIcon} />
                <a href="mailto:saidigitizing.orders@gmail.com" className={styles.contactLink}>
                  saidigitizing.orders@gmail.com
                </a>
              </div>
            </div>
            {/* <div className={styles.subscribe}>
              <input type="email" placeholder="Your Email Address" />
              <button>Subscribe</button>
            </div> */}
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p className="text-sm text-gray-400">
          © {new Date().getFullYear()} Saidigitizing. All Rights Reserved
        </p>
        <div className={styles.socialIcons}>
          <a href="https://www.facebook.com/profile.php?id=61578686090606" target="_blank" rel="noopener noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/sai_digitizing?igsh=MWxlZWM4Y2F2d2NuYg%3D%3D" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/in/sai-digitizing-7b8151233" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Fotter;
